import axios from "axios";

export const API_BASE_URL = "https://webback.piegroupllc.com"
// export const API_BASE_URL = "http://localhost:5000";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const getAdminId = () => localStorage.getItem("adminId");

export default api;
